
// import TopSearch from './TopSearch.vue'
import Personal from './Personal.vue'

const menuItems = [{
    name: '首頁/HOME',
    path: '/',
    icon: 'home'
}, {
    name: '探索/EXPLORE',
    path: '/explore',
    icon: 'explore'
}, {
    name: '立即預約/BOOK NOW',
    path: '/book-now',
    icon: 'book-now'
}, {
    name: '優惠推薦/DEAL',
    path: '/deal',
    icon: 'deal'
}, {
    name: '關於我們/ABOUT US',
    path: '/about-us',
    icon: 'about-us'
}]

export default {
    components: {
        Personal
    },
    data() {
        return {
            menuItems,
            showMy: false,
        }
    },
    props: {
        current: {
            type: Number,
            default: -1
        }
    },
    mounted() {
        if (this.$store.state.token) {
            this.showMy = true;
        }
    },
    methods: {
        to(index) {
            this.$emit('to', index);
        },
        link(index, url) {
            this.$router.push(url);
            //window.location.href = url;
        },
        showLogin() {
            this.$login.open();
        },
        showRegister() {
            this.$register.open();
        },
        toMy() {
            this.$router.push('/my');
        }
    }
}
